function processTokenError(tokenError) {
	if (tokenError && window.console && typeof window.console.error === 'function') {
		console.error(
			`Could not receive a social authorization token, proceeding without one`,
			tokenError
		);
	}
}

export { processTokenError };
